import { Link } from "react-router-dom";
import "../CSS/not-found.css";

const NotFound = () => {
  return (
    <div className="not-found">
      <span className="not-found_code">404</span>

      <h4>Page not found</h4>

      <p>The page you are looking for does not exist or has been moved.</p>

      <Link to="/dashboard" className="not-found_link">
        Back to dashboard
      </Link>
    </div>
  );
};

export default NotFound;
